import { Text } from 'foundations-components/components/Text';
import styled from 'styled-components';
import { Small } from 'foundations-components/transitional/components/Small';

// styled as StyledPolicyLink
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PrivacyTextIntegration = styled.div.withConfig({
  displayName: "CustomTermsAndConditions__PrivacyTextIntegration"
})(({
  theme
}) => {
  return {
    marginBottom: theme.space['200'],
    marginTop: theme.space['600'],
    fontFamily: theme.typography['body-125'].fontFamily,
    fontWeight: theme.typography['body-100'].fontWeight,
    fontSize: theme.typography['detail-200'].fontSize,
    lineHeight: theme.typography['detail-200'].lineHeight,
    fontLetterSpacing: theme.typography['detail-200'].letterSpacing
  };
});
export const StyledPrivacyBanner = styled.div.withConfig({
  displayName: "CustomTermsAndConditions__StyledPrivacyBanner"
})(["margin-top:", ";", ""], ({
  theme
}) => theme.space['500'], props => props.theme.embedded && `margin-top: ${props.theme.space['100']};`);
export const CustomTermsAndConditions = ({
  children,
  PrivacyPolicy
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "div",
    paddingInline: "400",
    children: /*#__PURE__*/_jsx(StyledPrivacyBanner, {
      children: /*#__PURE__*/_jsxs(Small, {
        use: "help",
        children: [/*#__PURE__*/_jsx(PrivacyTextIntegration, {
          children: children
        }), PrivacyPolicy]
      })
    })
  });
};